import { apiWithoutAuth } from "@/plugins/axios";

export function useCountryCode() {
  const getCountryCode = async () => {
    try {
      const ipResponse = await apiWithoutAuth.get(
        "https://api64.ipify.org?format=json"
      );
      const ip = ipResponse.ip;
      const response = await apiWithoutAuth.get(`https://ipinfo.io/${ip}/country`);
      const code = response.trim();
      return code
    } catch (error) {
      console.log('Error', error)
    }
  };
  return { getCountryCode };
}
